module.exports = __webpack_public_path__ + "static/4-c90373843719f62d59b8debd46ba47ef.png";